import Vue from 'vue'
import PromoCodesRepository from '@/repository/PromoCodesRepository'

Vue.mixin({
  methods: {
    checkPromoValidity: function(promoCodeHash) {
      return PromoCodesRepository.getInstance().checkPromoValidity(promoCodeHash)
    },
  },
})